var _defs, _rect, _rect2, _rect3, _path, _rect4, _polygon, _polygon2, _path2, _path3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousliving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 170.68,
    y: 209.01,
    width: 36.13,
    height: 6.22
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 170.68,
    y: 198.63,
    width: 36.13,
    height: 5.38
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 170.68,
    y: 185.74,
    width: 36.13,
    height: 7.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.05,151.67V217.3h-7.24V171.61a2.49,2.49,0,0,0-2.5-2.5H168.18a2.5,2.5,0,0,0-2.5,2.5V217.3h-7.23V151.67Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 170.68,
    y: 174.11,
    width: 36.13,
    height: 6.63
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "151.33 50.73 151.33 81 133.22 64.81 133.22 50.73 151.33 50.73"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "231.45 146.68 158.45 146.68 158.45 135.59 188.75 108.5 231.45 146.68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.22,174.11V217.3h30.6V174.11Zm24.56,22.65H100a2.5,2.5,0,1,1,0-5h5.82a2.5,2.5,0,0,1,0,5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.59,108.47V217.3H76.22V171.61a2.5,2.5,0,0,1,2.5-2.5h35.6a2.5,2.5,0,0,1,2.5,2.5V217.3h36.63V108.47Zm53.49,48.81a2.51,2.51,0,0,1-2.5,2.5h-38a2.51,2.51,0,0,1-2.5-2.5V118.65a2.5,2.5,0,0,1,2.5-2.5h38a2.5,2.5,0,0,1,2.5,2.5Zm50.17,0a2.51,2.51,0,0,1-2.5,2.5h-38a2.51,2.51,0,0,1-2.5-2.5V118.65a2.5,2.5,0,0,1,2.5-2.5h38a2.5,2.5,0,0,1,2.5,2.5Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.24,
    y: 121.15,
    width: 14.01,
    height: 14.32
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.23,
    y: 121.15,
    width: 14.01,
    height: 14.32
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.23,
    y: 140.47,
    width: 14.01,
    height: 14.31
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.24,
    y: 140.47,
    width: 14.01,
    height: 14.31
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.07,
    y: 140.47,
    width: 14.01,
    height: 14.31
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.07,
    y: 140.47,
    width: 14,
    height: 14.31
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.07,
    y: 121.15,
    width: 14,
    height: 14.32
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.07,
    y: 121.15,
    width: 14.01,
    height: 14.32
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "168.49 103.06 24.55 103.06 96.52 38.7 168.49 103.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousliving);
export default __webpack_public_path__ + "static/media/previousliving.629aae6e6a8161aea82975fb94a49189.svg";
export { ForwardRef as ReactComponent };